<template>
  <div>
    <strong>Versão 8.6.1</strong>
    <ul>
      <li>
        Ajustes conforme a Nota Técnica 6/2025 que define as notas e
        classificação agregada por equipe;
      </li>
      <li>
        Lançamento da evolução logo ao entrar no sistema, onde é possível ver o
        percentual de equipes com 100% de recursos federais;
      </li>
      <li>
        Ajuste da Pontuação para 2 casas decimais com o objetivo de aumentar a
        precisão no cálculo dos resultados;
      </li>
      <li>
        Ajuste do resultado municipal para estar adequado a Nota Técnica 6/2025;
      </li>
      <li>Outras melhorias e otimização para rapidez nas consultas.</li>
    </ul>
    <strong>Versão 8.5.0</strong>
    <ul>
      <li>
        Alteração do CARD Desempenho por ACS para Desempenho por Microárea onde
        é possível visualizar o percentual de visitas por microárea com
        possibilidade de selecionar períodos anteriores ao ano atual;
      </li>
      <li>
        Correções e ajustes nos card’s: Cidadãos Visitados, Famílias Visitadas,
        Relatório atendimentos, CEO, BPA C e BPA I;
      </li>
      <li>
        Descontinuação dos card’s Saúde da criança (o teste do pezinho vai virar
        uma boa prática no desenvolvimento infantil), Indicadores Previne
        Brasil, Informatiza APS e Pós-Covid 19 em virtude do cofinanciamento
        federal que está em vigor;
      </li>
      <li>
        Inclusão do CARD Importar em Imunização para importar os dados do
        SI-PNI;
      </li>
      <li>
        Adequação dos resultados e listas nominais as alterações das notas
        técnicas atualizadas dos indicadores da APS.
      </li>
    </ul>
    <strong>Versão 8.4.0</strong>
    <ul>
      <li>
        Filtro por <strong>Boas Práticas</strong> nos indicadores para
        visualizar a lista nominal e também o resultado percentual de pessoas
        com e sem a ação recomendada em cada boa prática;
      </li>
      <li>
        Pequenos ajustes nos indicadores, conforme as fichas técnicas
        atualizadas no dia 30/09/2025 pelo Ministério da Saúde;
      </li>
      <li>
        Boa pratica de vacinação no desenvolvimento infantil está prevista para
        ser atualizada até 24/10/2025.
      </li>
    </ul>
    <strong>Versão 8.3.0</strong>
    <ul>
      <li>
        Atualização do vínculo e acompanhamento de acordo com a portaria 7799 de
        20 de agosto de 2025 que eSF, eAP e eSFR;
      </li>
      <li>
        Ajustes no módulo cidadãos para incluir pendências de cadastro,
        atendimentos e procedimentos para a pessoa ser considerada no indicador;
      </li>
      <li>
        Atualização do aplicativo para android e IOS com as alterações da
        portaria 7799 de 20 de agosto de 2025;
      </li>
      <li>
        Inclusão do CARD Busca ativa cadastros para identificar cadastros que
        estão recebendo atendimento, mas não estão ativos no território;
      </li>
      <li>
        Alteração do CARD Cidadãos duplicados para mostrar os registros
        duplicados por cidadão, que antes mostrava somente um registro por
        cidadão, mesmo estando duplicado.
      </li>
    </ul>
    <strong>Versão 8.2.6</strong>
    <ul>
      <li>
        Ajustes para considerar os procedimentos (Aferição de PA, peso e altura
        e outros) inseridos a partir da escuta inicial, mesmo os códigos não
        estando nas Fichas Técnicas dos indicadores, entende-se que elas serão
        atualizadas também;
      </li>
      <li>
        Ajuste para identificar corretamente a microárea de acordo com a
        atualização do e-SUS PEC que atualizou o CNS dos profissionais Agentes
        de Saúde e outro que tinha mais de um CNS na tabela tb_dim_profissional;
      </li>
      <li>
        Ajuste para identificar corretamente as visitas puerperais conforme a
        data do parto;
      </li>
      <li>
        Ajuste para identificar as gestantes que tem duas gestações no período
        avaliado;
      </li>
      <li>
        Ajuste para não considerar hipertensos e diabéticos que estão com o
        problema ativo resolvido;
      </li>
      <li>
        Ajustes para considerar os procedimentos de odontologia registrados via
        CDS, mesmo não estando contemplados na Ficha Técnica do indicador, pois
        imaginamos que a Ficha Técnica será atualizada;
      </li>
      <li>
        Ajuste para considerar a escovação supervisionada conforme a atualização
        do e-SUS.
      </li>
    </ul>
    <strong>Versão 8.2.5</strong>
    <ul>
      <li>
        Inclusão do CARD Resultado Municipal para os Indicadores APS onde é
        possível visualizar o resultado consolidados dos indicadores por tipo de
        equipe (eSF, eAP, eMulti e eSB).
      </li>
    </ul>
    <strong>Versão 8.2.4</strong>
    <ul>
      <li>
        Ajustes dos resultados na aba Percentual para exibir o valor 0 (zero) em
        vez de - (traço) quando esse resultado existir.
      </li>
      <li>
        Ajuste nas listas de pessoas nos botões dos CARDS que apresentam as boas
        práticas relacionadas ao peso e altura e aferição de PA para apresentar
        o CBO do profissional que realizou o procedimento, bem como o Modelo de
        Informação (MI) utilizado no registro do procedimento.
      </li>
    </ul>
    <strong>Versão 8.2.3</strong>
    <ul>
      <li>
        Ao exportar PDF ou Excel, foi incluída a coluna PENDÊNCIAS que apresenta
        as boas práticas recomendadas para a pessoa e também a coluna Microárea.
        Essa alteração é para facilitar a busca ativa.
      </li>
    </ul>
    <strong>Versão 8.2.2</strong>
    <ul>
      <li>
        Ajustes visuais nas boas praticas: Consultas, Peso e Altura, aferição de
        PA e Visitas no <strong>CARD Gestantes Puérperas</strong> para exibir a
        pontuação somente com parto informado ou após a DPP no quadrimestre
        avaliado;
      </li>
      <li>
        Ajustes visuais nas boas práticas: Consultas, Peso e Altura, Visitas e
        Vacinas no <strong>CARD Desenvolvimento Infantil</strong> para exibir a
        pontuação somente nas crianças que tem 2 anos completos no quadrimestre
        avaliado.
      </li>
    </ul>
    <strong>Versão 8.2.1</strong>
    <ul>
      <li>
        Correção dos filtros e melhorias no CARD de Gestantes e Puérperas na
        visão da eSF / eAP e eSB.
      </li>
    </ul>
    <strong>Versão 8.2.0</strong>
    <ul>
      <li>
        Atualização do CARD Indicadores APS: eSF / eAP, eMulti e eSB com os
        indicadores de qualidade do cofinanciamento federal por equipe da APS.
      </li>
    </ul>
    <strong>Versão 7.2.0</strong>
    <ul>
      <li>
        Inclusão do CARD <strong>PSE</strong> para acompanhar os estudantes
        atendidos por atividade coletiva realizada;
      </li>
      <li>
        Inclusão do CARD <strong>IAF</strong> para acompanhar as práticas
        corporais e atividades físicas realizadas na UBS nos últimos 4 meses.
      </li>
    </ul>
    <strong>Versão 7.1.0</strong>
    <ul>
      <li>
        Em <strong>Vínculo e Acompanhamento</strong>, inclusão do CARD
        <strong>Avaliação do atendimentos</strong> com um vídeo demonstrativo,
        que ensina como o cidadão pode avaliar o atendimento pelo aplicativo Meu
        SUS Digital;
      </li>
      <li>
        Em <strong>vacina na idade certa</strong>, alteração da
        <strong>VIP</strong> para considerar o reforço de vacinação e
        <strong>exclusão</strong> do monitoramento da vacina
        <strong>VOP</strong>; Também consideração da vacina
        <strong>XBB</strong> no monitoramento e avaliação da vacina contra a
        Covid-19.
      </li>
      <li>
        Em HPV, alteração do monitoramento incluindo o filtro da faixa etária de
        15 a 19 anos, com atenção especial para o estado da Paraíba que pretende
        melhorar as coberturas vacinais dessa faixa etária.
      </li>
      <li>
        Alteração do CARD Condições de saúde para considerar filtrar os
        beneficiários do Bolsa Família (desde que o arquivo seja importado pelo
        administrador do e-SUS no prontuário eletrônico ou centralizador), além
        de pessoas idosas e crianças; Também Ajustes para considerar a população
        por micro-área, conforme o Território do e-SUS 5.3 em diante;
      </li>
      <li>
        Acesso unificado com a inclusão da possibilidade de acessar esse sistema
        utilizando a mesma senha do prontuário eletrônico ou do aplicativo do
        Agente de Saúde.
      </li>
    </ul>
    <strong>Versão 7.0.0</strong>
    <ul>
      <li>
        Atualizamos o <strong>Vínculo e Acompanhamento</strong> de acordo com a
        Portaria GM/MS nº 3.493/2024 que descreve a nova metodologia de
        cofinanciamento federal da APS
      </li>
      <li>
        Inclusão do card <strong>Desempenho por Equipe</strong> que demonstra os
        dados consolidados de pessoas e o desempenho por equipe do vínculo e
        acompanhamento. Na aba Equipes é possível identificar a localização no
        mapa das equipes do município, bem como a quantidade mínima e máxima de
        pessoas por equipe. Essa funcionalidade auxilia na decisão sobre a
        necessidade de realizar ou não remapeamento para equilibrar a quantidade
        de pessoas por equipe.
      </li>
      <li>
        Atualizamos o card <strong>Cadastros Cidadãos</strong>, apresentando
        dados sobre a completude e atualização dos cadastros, considerando os
        cadastros individuais e domiciliares (FCI e FCDT). Foram inseridas as
        abas de Percentual e Escore.
      </li>
      <li>
        Atualizamos o card  <strong>Acompanhamento</strong>. Foram inseridas as
        abas de Percentual e Escore. O escore auxilia para mensurar a
        efetividade das ações realizadas pelas equipes de Atenção Primária à
        Saúde (APS)
      </li>
      <li>
        O escore apresenta a classificação da equipe conforme o vínculo e
        acompanhamento do cofinanciamento federal. Importante importar os
        cidadãos beneficiários do Bolsa Família no PEC ou PEC Centralizador para
        que o escore esteja o mais perto possível da classificação que a equipe
        vai ter no quadrimestre.
      </li>
    </ul>

    <strong>Versão 6.6.0</strong>
    <ul>
      <li>
        Atualizamos o <strong>CARD BPA E RAS</strong> com a capacidade de gerar
        o <strong>BPA (Consolidado e Individualizado)</strong>. As fichas
        <strong>BPA I</strong> e <strong>BPA C</strong> são utilizados para
        serem digitadas no SIA SUS. Agora é possível gerar essas fichas
        diretamente aqui para evitar o trabalho manual de processar elas.
      </li>
    </ul>

    <strong>Versão 6.5.0</strong>
    <ul>
      <li>
        Inclusão do CARD <strong>CEO</strong> que contem a produção por
        competência, bem como o monitoramento das metas por categoria de
        procedimentos executados. Essa funcionalidade é útil para os municípios
        que usam o e-SUS PEC CEO monitorarem sua produção.
      </li>
    </ul>

    <strong>Versão 6.4.0</strong>
    <ul>
      <li>
        Adequação das vacinas <strong>HPV</strong> (HPV e 0 – 15 ANOS) e
        <strong>Hepatite B</strong> (0 – 15 ANOS) ao calendário de vacinação
        definido pela "INSTRUÇÃO NORMATIVA DO CALENDÁRIO NACIONAL DE VACINAÇÃO
        2024".
      </li>
    </ul>

    <strong>Versão 6.3.0</strong>
    <ul>
      <li>
        Inclusão do Card <b>TRIA</b> que apresenta Triagem para Risco de
        Insegurança Alimentar (TRIA) na APS por família.
      </li>
    </ul>

    <strong>Versão 6.2.0</strong>
    <ul>
      <li>
        Inclusão do Card <b>Vínculo e acompanhamento</b> (Diagnóstico
        situacional, Cadastros, Acompanhamentos). Essa funcionalidade atende aos
        requisitos do componente de vínculo e acompanhamento do cofinanciamento
        federal da APS;
      </li>
      <li>
        No <b>cadastro</b>, é possível identificar os cidadãos que estão com e
        sem atualização do cadastro FCI, bem como em que medida de 0 a 100%, a
        FCI está ou não completa;
      </li>
      <li>
        No <b>acompanhamento</b> é possível identificar os cidadãos que estão
        com e sem acompanhamento (atendimento de medicina, enfermagem,
        procedimento, profissionais da eMulti, visitas dos ACS, atendimento
        odontológico ou atividade coletiva);
      </li>
      <li>
        No diagnóstico situacional é possível identificar a localização no mapa
        das equipes do município, bem como a quantidade mínima e máxima de
        pessoas por equipe. Essa funcionalidade ajuda na decisão sobre a
        necessidade de realizar ou não remapeamento para equilibrar a quantidade
        de pessoas por equipe.
      </li>
    </ul>

    <strong>Versão 6.0.0</strong>
    <ul>
      <li>
        Ajustes da home page para refletir os requisitos do cofinanciamento
        federal da APS;
      </li>
      <li>
        Inclusão na área de acesso público das funcionalidades: Mapa IED, Mapa
        UBS e Simulação;
      </li>
      <li>
        A simulação permite visualizar relatório com projeção dos repasses
        mensais e anuais de acordo com a classificação do município;
      </li>
      <li>
        O mapa UBS está sendo atualizado. Então se ainda não tiver disponível
        para seu município, pode aguardar que vai estar em breve;
      </li>
      <li>
        Tracejado no link Previne Brasil para indicar que foi descontinuado, mas
        as informações ficarão disponíveis ainda;
      </li>
      <li>
        Em breve, teremos outra versão com o CARD de Vínculo e Acompanhamento.
      </li>
    </ul>

    <strong>Versão 5.13.0</strong>
    <ul>
      <li>
        Inclusão de novos perfis: Coordenador(a) de Vigilância em Saúde,
        Coordenador(a) de Imunização, Técnico ou Auxiliar de Saúde Bucal,
        Vacinador(a) e Agente Comunitário de Endemias(a).
      </li>
    </ul>

    <strong> Versão 5.12.0</strong>

    <ul>
      <li>
        Inclusão do CARD <strong>Aedes Aegypti</strong> Atendimentos e visitas
        em cidadãos com presença do vetor transmissor da dengue. Os que estão
        vermelhos merecem atenção, pois são atendimentos recentes e podem
        indicar presença de foco.
      </li>
    </ul>

    <strong>Versão 5.11.0</strong>

    <ul>
      <li>
        Inclusão do CARD Gestão Cadastros >> Óbitos que apresenta a lista de
        cidadãos com informação de óbito no cadastro;
      </li>
      <li>
        Inclusão do CARD Gestão Cadastros >> Óbitos que apresenta a lista de
        cidadãos com informação de óbito no cadastro;
      </li>
    </ul>

    <strong>Versão 5.10.0</strong>

    <ul>
      <li>
        Alteração do CARD
        <strong>Imunização >> Vacina idade certa >> 0 – 2 anos</strong> PARA
        <strong>Imunização >> Vacina idade certa >> 0 – 15 anos.</strong>
        Com inteligência para identificar as crianças e adolescentes de 0 (zero)
        a 15 (quinze) anos de idade que estão com dose de vacinação em atraso;
      </li>
      <li>
        Inclusão do CARD <strong>Imunização >> Dose Imunizante</strong> que
        apresenta vacinas e doses preconizadas nos indicadores do PNI para as
        crianças de 0 (zero) a 15 (quinze) meses de idade;
      </li>
    </ul>

    <strong>Versão 5.9.0</strong>

    <ul>
      <li>
        Inclusão do CARD <strong>Produção >> Procedimentos</strong> que
        apresenta a possibilidade de exportar os procedimentos em um intervalo
        de 30 dias definido pelo usuário. É possível contar os procedimentos por
        UBS, por profissional, por CBO e outros. A exportação é feita em
        planilha excel que permite o tratamento e a implementação de outros
        filtros que usuário ache necessário;
      </li>
      <li>
        Inclusão do CARD
        <strong>Gestão Cadastros >> Calculadora de pessoas</strong>. Onde é
        possível visualizar a quantidade de pessoas por equipe e idade de forma
        que seja possível visualizar rapidamente e facilmente a quantidade de
        pessoas no território.
      </li>
    </ul>

    <strong>Versão 5.8.0</strong>

    <ul>
      <li>
        Alteração no filtro <strong>Último atendimento</strong> nos CARDS dos
        Indicadores na APS (Hipertensão e Diabetes) para
        <strong>visualizar atendimentos nos últimos 30 dias, 2 e 3 meses</strong
        >. Isso permite identificar atendimentos recentes e que não tiveram CID
        ou CIAP de hipertensão ou diabetes (estão vermelho na lista nominal), o
        que é sugestivo para necessidade de registro complementar via CDS a fim
        de qualificar o atendimento nos indicadores;
      </li>
      <li>
        Alteração no <strong>filtro idade para grupos</strong> no CARD
        <strong>Exames citopatológico</strong> para visualizar as mulheres com
        atendimentos recente, mas sem o registro do procedimento clínico de
        citopatológico (estão vermelhos na lista nominal), o que sugere
        realização do procedimento ou outro tipo de atendimento. Também poderia
        ter registro complementar no CDS para qualificar o atendimento ao
        indicador nos casos em que se teve a realização do citopatológico na
        UBS. Outra melhoria foi a Inclusão da data do último atendimento
        realizado na mulher.
      </li>
    </ul>

    <strong>Versão 5.7.4</strong>

    <ul>
      <li>
        Alteração do CARD <strong>Desempenho geral</strong> para mostrar na
        lista as equipes que estão com denominador zerado em pré-natal ou
        crianças de um ano no indicador de imunização para o quadrimestre
        avaliado;
      </li>
      <li>
        Alteração dos <strong>Resultados</strong> nos CARDS:
        <strong
          >Citopatológico, Atendimento Hipertensão e Atendimento
          Diabetes</strong
        >
        para mostrar o resultado a nível municipal de acordo com a atualização
        disponibilizada SISAB no quadrimestre atual. Essa otimização vai
        aumentar a precisão em relação ao resultado liberado no SISAB;
      </li>
      <li>
        Alteração do <strong>Resultado</strong> no CARD
        <strong>Cidadãos visitados</strong> para mostrar a quantidade
        relacionada a porcentagem.
      </li>
    </ul>

    <strong>Versão 5.7.3</strong>

    <ul>
      <li>
        Alteração do CARD <strong>Cadastros cidadãos</strong> para incluir a
        quantidade de cidadãos atualizados e quantidade de cidadãos
        desatualizados. Os resultados SISAB irão ficar incluídos no gráfico de
        barras.
      </li>
    </ul>

    <strong>Versão 5.7.2</strong>

    <ul>
      <li>
        Alteração no CARD <strong>Envio APP ACS PEC</strong> para que a
        <strong>Última visita</strong> mostre a maior data entre as visitas
        registradas, em vez de o último registro. Essa melhoria é para atender
        cidades que usam aplicativos de terceiros ou próprios (SISTEMA EXTERNO);
      </li>
    </ul>

    <strong>Versão 5.7.1</strong>

    <ul>
      <li>
        Foi incluído no CARD <strong>Envio APP ACS PEC</strong> as colunas:
        <strong>Fichas visitas</strong> (quantidade de fichas produzidas pelo
        ACS), <strong>Média equipe</strong> (média das fichas das visitas
        produzidas pelos ACS da equipe) e
        <strong>Média municipal</strong> (média das fichas de visitas produzidas
        no município).
        <strong
          >As quantidades dessas colunas contem dados dos últimos 30 dias a
          contar de hoje para trás.</strong
        >
      </li>
    </ul>

    <strong>Versão 5.7.0</strong>

    <ul>
      <li>
        No CARD <strong>Administração</strong>, foi criado o CARD
        <strong>Alterar logotipo</strong> que permite mudar a logo que aparece
        antes do nome da cidade na versão Web. Para ter acesso a essa
        funcionalidade, faz-se necessário solicitar ativação dela ao suporte do
        eSUS Feedback.
      </li>
      <li>
        No CARD <strong>Relatório atendimentos</strong>, foi incluído também
        para a <strong>Ação Detalhar</strong>, o quantitativo por turno, quando
        o profissional de saúde é o Técnico ou Auxiliar de Enfermagem. Foi
        incluído também o <strong>botão de ajuda</strong> (?) com informações
        importantes.
      </li>
    </ul>

    <strong>Versão 5.6.6</strong>
    <ul>
      <li>
        Alteração do nome do CARD <strong>Comorbidades</strong> para
        <strong>Condições Saúde</strong> e ajuste nos nomes dos filtros de
        hipertensão, diabetes e problemas de saúde mental;
      </li>
      <li>
        No CARD <strong>Visitas domiciliares</strong>, foi corrigido o mapa para
        mostrar a localização das visitas que são registradas com
        georreferenciamento a partir do aplicativo dos ACS.
      </li>
    </ul>
    <strong>Versão 5.6.5</strong>
    <ul>
      <li>
        Disponibilidade do CARD <strong>Comorbidades</strong> que apresenta as
        condições de saúde por cidadão;
      </li>
      <li>
        No CARD <strong>Relatório atendimentos</strong>, foi incluída a busca
        por <strong>UBS</strong> e dentro da busca, pode ser realizado a
        filtragem pelas <strong>Equipes</strong> vinculadas a UBS. Isso é útil
        para os estabelecimentos que tem mais de uma equipe;
      </li>
      <li>
        No CARD <strong>Relatório atendimentos</strong>, quando se acessa a
        <strong>Ação Detalhar</strong>, então é possível incluir um filtro por
        data específica dentro do período dos últimos 90 dias;
      </li>
      <li>
        Quando o médico(a), enfermeiro(a) ou odontólogo(a) acessa o sistema, ele
        vai poder escolher a equipe que deseja visualizar os dados. Isso é útil
        para os profissionais que tem mais de uma lotação cadastrada dentro do
        e-SUS PEC ou Centralizador.
      </li>
    </ul>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
